<template>
  <main>
    <Navbar />
    <div class="container">
      <v-card class="login-card" elevation="8" rounded="lg">
        <v-card-title class="text-h6 text-center white--text py-0 text">
          <h1>Recuperação de Senha</h1>
        </v-card-title>

        <v-card-text class="pt-0">
          <!-- Etapa 1: Inserir telefone -->
          <v-form
            v-if="etapa === 1"
            @submit.prevent="enviarCodigoEmail"
            v-model="formValidEmail"
            ref="form1"
          >
            <span class="text-h6 text-center white--text pb-0"
              >Informe seu e-mail para continuar</span
            >
            <v-text-field
              v-model="user.email"
              label="E-mail"
              outlined
              color="white"
              class="custom-text-field mt-4 mb-0"
              :rules="emailRules"
              hide-details="auto"
              required
              dark
              density="compact"
            ></v-text-field>
            <v-btn variant="text" @click="etapa = 2" class="esqueci-link">
              Esqueci meu e-mail
            </v-btn>
            <v-btn
              block
              color="white"
              type="submit"
              :disabled="!formValidEmail || loading"
              :loading="loading"
              class="text--primary mt-4"
              height="35"
              rounded="lg"
              style="color: #343f53 !important"
            >
              Continuar
            </v-btn>
          </v-form>

          <!-- Etapa 2: Validar código -->
          <v-form
            v-if="etapa === 2"
            @submit.prevent="enviarCodigoTelefone"
            v-model="formValidTelefone"
            ref="form2"
          >
            <span class="text-h7 text-center white--text pb-0"
              >Informe seu telefone para continuar</span
            >
            <v-text-field
              v-model="user.telefone"
              label="Telefone"
              outlined
              color="white"
              class="custom-text-field mt-4"
              v-mask="'(##) #####-####'"
              :rules="telefoneRules"
              hide-details="auto"
              required
              dark
              density="compact"
            ></v-text-field>
            <v-btn
              block
              color="white"
              type="submit"
              :disabled="!formValidTelefone || loading"
              :loading="loading"
              class="text--primary mt-6"
              height="35"
              rounded="lg"
              style="color: #343f53 !important"
            >
              Continuar
            </v-btn>

            <v-btn
              variant="text"
              :disabled="etapa === 1"
              @click="etapa = 1"
              class="voltar-link mt-2"
            >
              Voltar
            </v-btn>
          </v-form>

          <!-- Etapa 3: Nova senha -->
          <v-form
            v-if="etapa === 3"
            @submit.prevent="alterarSenha"
            v-model="formValidSenha"
            ref="form4"
          >
            <div class="text-center white--text mt-4">
              <p>
                Insira o código de 5 dígitos enviado para o telefone com final
                {{ userRequest.telefone.substring(6, 10) }}
              </p>
            </div>

            <v-otp-input
              v-model="user.token"
              :length="5"
              type="number"
              :disabled="loading"
              class="custom-otp-input mx-4"
              dark
            ></v-otp-input>
            <div class="d-flex justify-space-between align-center mb-6">
              <v-btn
                variant="text"
                @click="reenviarToken()"
                :class="{ 'disabled-link': isWaiting }"
                class="voltar-link"
                :disabled="isWaiting"
              >
                {{
                  isWaiting
                    ? `Reenviar em ${tempoRestante}s`
                    : "Reenviar código"
                }}
              </v-btn>
            </div>
            <v-text-field
              v-model="user.novaSenha"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              label="Nova senha"
              outlined
              color="white"
              class="custom-text-field mt-4"
              :rules="senhaRules"
              hide-details="auto"
              required
              dark
              density="compact"
              @click:append="showPassword = !showPassword"
            ></v-text-field>

            <v-text-field
              v-model="user.confirmacaoSenha"
              :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showConfirmPassword ? 'text' : 'password'"
              label="Confirme a nova senha"
              outlined
              color="white"
              class="custom-text-field mt-4"
              :rules="[...senhaRules, confirmarSenhaRule]"
              hide-details="auto"
              required
              density="compact"
              dark
              @click:append="showConfirmPassword = !showConfirmPassword"
            ></v-text-field>

            <v-btn
              block
              color="white"
              type="submit"
              class="text--primary mt-6"
              height="35"
              rounded="lg"
              style="color: #343f53 !important"
              :disabled="!formValidSenha || loading"
              :loading="loading"
            >
              Alterar Senha
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
    <Footer />
  </main>
</template>

<script>
import Footer from "@/components/landingpage/Footer.vue";
import Navbar from "@/components/landingpage/adm/Navbar.vue";
import { http } from "@/services/config";
import { useToast } from "vue-toastification";
import { mask } from "vue-the-mask";

const toast = useToast();

export default {
  components: {
    Footer,
    Navbar,
  },
  directives: {
    mask,
  },
  data() {
    return {
      etapa: 1,
      formValidEmail: false,
      formValidTelefone: false,
      formValidToken: false,
      formValidSenha: false,
      loading: false,
      showPassword: false,
      showConfirmPassword: false,
      isWaiting: false,
      tempoRestante: 0,
      intervalId: null,
      tipoRequest: null,
      userRequest: {
        id_usuario: null,
        telefone: "",
        senha: "",
        token: null,
      },
      user: {
        email: "",
        telefone: "",
        token: "",
        novaSenha: "",
        confirmacaoSenha: "",
      },

      emailRules: [
        (v) => !!v || "E-mail é obrigatório",
        (v) => {
          if (!v) return true; // Se estiver vazio, retorna válido
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(v) || "Por favor, insira um e-mail válido";
        },
      ],

      telefoneRules: [
        (v) => !!v || "Telefone é obrigatório",
        (v) => (v && v.replace(/\D/g, "").length === 11) || "Telefone inválido",
      ],
      senhaRules: [
        (v) => !!v || "Senha é obrigatória",
        (v) =>
          (v && v.length >= 6) || "A senha deve ter no mínimo 6 caracteres",
      ],
    };
  },
  computed: {
    confirmarSenhaRule() {
      return () =>
        this.user.novaSenha === this.user.confirmacaoSenha ||
        "As senhas não conferem";
    },
  },
  methods: {
    iniciarTemporizador() {
      this.isWaiting = true;
      this.tempoRestante = 120;

      if (this.intervalId) {
        clearInterval(this.intervalId);
      }

      this.intervalId = setInterval(() => {
        if (this.tempoRestante > 0) {
          this.tempoRestante--;
        } else {
          this.pararTemporizador();
        }
      }, 1000);
    },

    pararTemporizador() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
      this.isWaiting = false;
      this.tempoRestante = 0;
    },

    reenviarToken() {
      if(this.tipoRequest === "email") {
        this.formValidEmail = true;
        this.enviarCodigoEmail();
      } else if(this.tipoRequest === "telefone") {
        this.formValidTelefone = true;
        this.enviarCodigoTelefone();
      }
      this.pararTemporizador();
      this.iniciarTemporizador();
    },

    async enviarCodigoEmail() {
      if (!this.formValidEmail) {
        toast.error("Preencha o e-mail corretamente");
        return;
      }

      try {
        this.loading = true;
        this.tipoRequest = "email"
        const response = await http.post(`/api/auth/validar-contato`, null, {
          params: {
            valor: this.user.email,
            tipo: this.tipoRequest,
          },
        });

        if (response.status === 200 && response.data.mensagem === "Token enviado com sucesso") {
          this.userRequest.id_usuario = response.data.id_usuario;
          this.userRequest.telefone = response.data.telefone;
          this.etapa = 3;
          this.iniciarTemporizador();
          this.loading = false;
        } else {
          toast.error("Erro ao enviar o código");
        }
      } catch (error) {
        console.error("Erro ao enviar código:", error);
        toast.error(
          "Erro ao enviar o código. Verifique se o e-mail está cadastrado."
        );
        this.loading = false;
      }
    },

    async enviarCodigoTelefone() {
      if (!this.formValidTelefone) {
        toast.error("Preencha o telefone corretamente");
        return;
      }

      try {
        const phoneTratado = this.user.telefone.replace(/\D/g, "");
        this.loading = true;
        this.tipoRequest = "telefone"
        const response = await http.post(`/api/auth/validar-contato`, null, {
          params: {
            valor: phoneTratado,
            tipo: this.tipoRequest,
          },
        });

        if (response.status === 200 && response.data.mensagem === "Token enviado com sucesso") {
          this.userRequest.id_usuario = response.data.id_usuario;
          this.userRequest.telefone = response.data.telefone;
          this.etapa = 3;
          this.iniciarTemporizador();
        } else {
          toast.error("Erro ao enviar o código");
        }
      } catch (error) {
        console.error("Erro ao enviar código:", error);
        toast.error(
          "Erro ao enviar o código. Verifique se o telefone está cadastrado."
        );
      } finally {
        this.loading = false;
      }
    },

    async alterarSenha() {
      if (!this.formValidSenha) {
        toast.error("Preencha todos os campos corretamente");
        return;
      }

      if (this.user.novaSenha !== this.user.confirmacaoSenha) {
        toast.error("As senhas não conferem");
        return;
      }

      try {
        this.loading = true;

        const response = await http.post("/api/auth/redefinir-nova-senha", {
          id_usuario: this.userRequest.id_usuario,
          token: this.user.token,
          telefone: this.userRequest.telefone,
          senhaNova: this.user.novaSenha,
        });

        if (response.status === 200) {
          toast.success("Senha alterada com sucesso!");
          setTimeout(() => {
            this.$router.push("/");
          }, 1500);
        } else {
          toast.error("Erro ao alterar a senha");
        }
      } catch (error) {
        console.error("Erro ao alterar a senha:", error);
        toast.error("Erro ao alterar a senha!");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Sora:wght@100..800&display=swap");

* {
  margin: 0;
  padding: 0;
  font-family: "Sora", sans-serif;
}

main {
  background-image: url("@/assets/images/Elementos/fundo.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}

.container {
  min-height: 80vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}

.text {
  color: #ffffff;
  height: 4rem;
}

.crie {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 4rem;
}

.text p {
  font-size: 31px;
  font-weight: 300;
}

.text h1 {
  font-size: 30px;
  font-weight: 800;
  line-height: 5rem;
  text-align: center;
}

.login-card {
  width: 500px;
  max-width: 90%;
  background-color: #343f53 !important;
  color: #ffffff;
  text-align: center;
  padding: 1rem;
}

.login-card .v-card-title {
  justify-content: center;
  padding-top: 1.5rem;
  font-weight: 600;
}

.login-card .v-card-text {
  padding: 1rem 2rem 2rem;
}

/* Estilo personalizado para campos de texto */
.custom-text-field {
  margin-bottom: 1rem;
}

/* Estilização dos inputs do Vuetify */
.custom-text-field.v-text-field--outlined >>> fieldset {
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.custom-text-field.v-text-field--outlined >>> .v-label {
  color: rgba(255, 255, 255, 0.7) !important;
}

.custom-text-field.v-text-field--outlined >>> input {
  color: white !important;
}

/* Estilização do botão */
.v-btn.text--primary {
  font-weight: 600;
  transition: background-color 0.3s;
}

.v-btn.text--primary:hover {
  background-color: #e0e0e0;
  opacity: 0.9;
}

.cursor-pointer {
  cursor: pointer;
}

.disabled-link {
  opacity: 0.6;
  cursor: not-allowed;
}

.esqueci-link {
  color: white;
  cursor: pointer;
  font-weight: 400;
  font-size: 10px;
  transition: opacity 0.3s ease;
}

.esqueci-link:hover {
  opacity: 0.5;
}

.voltar-link {
  color: white;
  cursor: pointer;
  font-weight: 400;
  font-size: 16px;
  transition: opacity 0.3s ease;
  text-transform: capitalize;
}

.voltar-link:hover {
  opacity: 0.5;
}

.custom-otp-input >>> .v-otp-input {
  justify-content: center;
}

.custom-otp-input >>> .v-otp-input__input {
  color: white !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  border-radius: 4px;
  width: 40px !important;
  height: 50px !important;
  margin: 0 5px;
  font-size: 1.2rem;
}

@media (max-width: 1037px) {
  .container {
    flex-direction: column;
  }

  .text h1 {
    font-size: 50px;
    line-height: 2.5rem;
  }

  .login {
    padding: 1rem 1.5rem;
  }
}
</style>
